module.exports = __webpack_public_path__ + "static/media/19ESCAP26.fbc56c81.jpg";